import cn from "classnames";
import React from "react";

const RemoveSvg = ({ quantity }) => {
  return (
    <svg
      width="14"
      height="3"
      viewBox="0 0 14 3"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Minus node</title>
      <path
        d="M1.25 2.25C1.0375 2.25 0.859417 2.17808 0.71575 2.03425C0.571917 1.89042 0.5 1.71225 0.5 1.49975C0.5 1.28708 0.571917 1.109 0.71575 0.9655C0.859417 0.821833 1.0375 0.75 1.25 0.75H12.75C12.9625 0.75 13.1406 0.821917 13.2843 0.96575C13.4281 1.10958 13.5 1.28775 13.5 1.50025C13.5 1.71292 13.4281 1.891 13.2843 2.0345C13.1406 2.17817 12.9625 2.25 12.75 2.25H1.25Z"
        className={cn("fill-lightBlack dark:fill-lightWhite", {
          " !fill-white": quantity > 1,
        })}
      />
    </svg>
  );
};

export default RemoveSvg;
